import { render, staticRenderFns } from "./Freelancers.vue?vue&type=template&id=16c807b4"
import script from "./Freelancers.vue?vue&type=script&lang=js"
export * from "./Freelancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports